<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { remoteLinkLandingRouteFor } from '@/router/landing';

const auth = useAuthStore();
const route = useRoute();
const router = useRouter();
const status = ref<'pending' | 'error'>('pending');

onMounted(async () => {
  const rawKey = route.query.key;
  const key = Array.isArray(rawKey) ? rawKey[0] : rawKey;
  if (typeof key !== 'string' || key.length === 0) {
    await router.replace({ name: 'main' });
    return;
  }

  try {
    const user = await auth.remoteLinkLogin(key);
    const reservationCode =
      typeof user.reservation_code === 'string' && user.reservation_code.length
        ? user.reservation_code
        : undefined;
    const target = reservationCode
      ? remoteLinkLandingRouteFor(auth, { reservationCode })
      : remoteLinkLandingRouteFor(auth);
    await router.replace(target);
  } catch {
    status.value = 'error';
    await router.replace({ name: 'main' });
  }
});
</script>

<template>
  <main class="remote-link">
    <p v-if="status === 'pending'">Signing you in…</p>
    <p v-else>Sign-in link is invalid or has expired. Redirecting…</p>
  </main>
</template>

<style scoped>
.remote-link {
  max-width: 28rem;
  margin: 6rem auto;
  padding: 1.5rem;
  text-align: center;
  font-size: 1rem;
  color: #4b5563;
}
</style>
